export const INVENTORY_MANUAL_UPDATE_ACTIONS = {
  updateQuantities: 'updateQuantities',
  updateQuantitiesViaCsvUpload: 'updateQuantitiesViaCsvUpload',
  setVariantBuffersViaCSV: 'setVariantBuffersViaCSV',
};
